import React from 'react';
import {Card, CardBody, Row, Col} from "reactstrap";
import IconInput from 'components/iconInput/IconInput';
import { useTranslation } from 'react-i18next';
import { useFetchData } from 'hooks/apiHooks';
import ApiError from 'components/common/ApiError';
import Skeleton from 'react-loading-skeleton';
import APIResultMessage from 'components/common/APIResultMessage';
import Toolbar from 'components/common/Toolbar';
import { API_ENDPOINTS } from 'constants';
import { useComponentDetails } from 'hooks/useComponentDetails';
import PieChart from 'components/dashboard/PieChart';
import BarChart from 'components/dashboard/BarChart';
import LineChart from 'components/dashboard/LineChart';

const CompaniesDashboard = ({ selectedItem, toggleReports, context }) => {
    const { t } = useTranslation();
    const { data, isLoading, error, refetch } = useFetchData(API_ENDPOINTS.REPORTS.COMPANIES)
    
    const companyOverview = data?.company_overview
    const totalCompanies = data?.total_companies
    const companySegments = data?.company_segments
    const communication = data?.communication
    const runningCommunication = data?.communication_data
    const timeline = data?.by_month

    const {toolbar} = useComponentDetails(null, null, null, null, toggleReports)
    const toolbarItems = [ toolbar.closeReports ]
    

    if (isLoading) return <Skeleton height={30} count={20} />;
    if (error) return <ApiError retryFetch={refetch} errorMessage={error.message}/>

    console.log(data)
    return (
        <Card className="card-tasks" style={{height:"auto", marginLeft:"10px",    borderRadius: '0.875rem', overflow:'hidden'}}>
            <Row>
                <Col md={12}>
                    <Toolbar items={toolbarItems.filter(item => item.visible)}/>
                </Col>
            </Row>
            <Row>
                <Col md="3">
                    <PieChart 
                        title={t('reports.title.CompaniesTotal')}
                        icon='icon-single-02'
                        total={companyOverview.total_companies}
                        colorScheme='blue'
                        input={totalCompanies}
                    />
                </Col>
                <Col md="6">
                    <BarChart 
                        title={t('reports.title.CommunicationPotential')}
                        legend={t('reports.label.number')}
                        input={communication} 
                        total={data.unique_emails}
                        icon='icon-send'
                        colorScheme = 'purple'
                    />
                </Col>
                <Col md="3">
                    <PieChart 
                        title={t('reports.title.runningCommunication')}
                        legend={t('reports.label.number')}
                        input={runningCommunication} 
                        total={companyOverview.total_companies}
                        icon='icon-spaceship'
                        colorScheme='green'
                    />
                </Col>
                <Col md="6">
                    <LineChart 
                        title={t('reports.title.companyDetails')}
                        legend={t('reports.label.number')}
                        input={timeline.avg_employees} 
                        total={companyOverview.total_companies}
                        icon='icon-zoom-split'
                        colorScheme = 'yellow'
                    />
                </Col>
                <Col md="6">
                    <LineChart 
                        title={t('reports.title.companyDetails')}
                        legend={t('reports.label.usd')}
                        input={timeline.avg_revenue} 
                        total={companyOverview.total_companies}
                        icon='icon-zoom-split'
                        colorScheme = 'red'
                    />
                </Col>
            </Row>
        </Card>
    )
}

export default CompaniesDashboard;